import React, { useState, useEffect } from 'react'
import FetchApi from '../../../customhooks/functionFetchApi'
import { FaCheck } from "react-icons/fa";

const Statusall = ({ id, statusNow, stateSuccesfull }) => {
    const [journallist, setJournallist] = useState([])

    useEffect(() => {
        const FetchApis = new FetchApi();
        FetchApis.FethcGet(`/journal/getStatejournalById/${id}`).then((res) => {
            if (res) {
                setJournallist(res.data.data)
            }
        })
    }, [id]);

    if (journallist.length === 0) {
        return <div></div>
    }

    // group by stateflow, step is done only if ALL approvers in that step have active=1
    const stepMap = {};
    journallist.forEach(item => {
        const step = Number(item.stateflow);
        if (!stepMap[step]) stepMap[step] = { step, allDone: true };
        if (Number(item.active) !== 1) stepMap[step].allDone = false;
    });
    const steps = Object.values(stepMap).sort((a, b) => a.step - b.step);

    if (statusNow > stateSuccesfull) {
        return (
            <div style={{
                display: 'inline-flex', alignItems: 'center', gap: 4,
                backgroundColor: '#d1fae5', color: '#065f46',
                border: '1px solid #6ee7b7', borderRadius: 20,
                padding: '2px 8px', fontWeight: 600, fontSize: 10,
                whiteSpace: 'nowrap', lineHeight: 1.4,
            }}>
                <FaCheck size={8} /> เสร็จเรียบร้อย
            </div>
        );
    }

    const getBarColor = (s) => {
        if (s.step < Number(statusNow)) return '#22c55e';
        if (s.step === Number(statusNow)) return '#f59e0b';
        return '#d1d5db';
    };

    return (
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
            {steps.map((s) => (
                <div
                    key={s.step}
                    title={`ขั้นตอน ${s.step}`}
                    style={{
                        width: 5, height: 14,
                        borderRadius: 3,
                        backgroundColor: getBarColor(s),
                        flexShrink: 0,
                        opacity: s.step > Number(statusNow) ? 0.35 : 1,
                        boxShadow: s.step <= Number(statusNow) ? `0 1px 3px ${getBarColor(s)}88` : 'none',
                    }}
                />
            ))}
        </div>
    );
}

export default Statusall